import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

export const ErrorDisplay = ({ error }: { error: string }) => (
	<Box
		sx={{
			width: '100%%',
			marginTop: '150px',
			display: 'flex',
			justifyContent: 'center',
		}}
	>
		<Typography
			variant='h5'
			style={{
				fontWeight: 500,
				width: '70%',
				textAlign: 'center',
			}}
		>
			{error}
		</Typography>
	</Box>
);
